import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.77,9.09,8.54,14.52a.75.75,0,0,1-.54.23.76.76,0,0,1-.54-.23L2.23,9.09A.75.75,0,0,1,2.25,8a.76.76,0,0,1,1.06,0l3.94,4.09V2a.75.75,0,0,1,1.5,0V12.14l3.94-4.09a.76.76,0,0,1,1.06,0A.75.75,0,0,1,13.77,9.09Z';
const draw24px =
  'M17.77,15.1l-5.23,5.42a.76.76,0,0,1-.54.23.75.75,0,0,1-.54-.23L6.23,15.1a.75.75,0,0,1,0-1.06.75.75,0,0,1,1.06,0l3.94,4.08V4a.75.75,0,0,1,1.5,0V18.14l3.94-4.08a.75.75,0,0,1,1.08,1Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowDownIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowDown'),
) as IconWithRender;

ArrowDownIcon.displayName = 'ArrowDownIcon';
ArrowDownIcon.propTypes = Icon.propTypes;
ArrowDownIcon.renderIcon = (props) => <ArrowDownIcon {...props} />;
export default ArrowDownIcon;
